import React, { useEffect, useState } from 'react';
import useRequest from '../../../../hooks/useRequest';
import './FooterLastColumn.scss';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import FloatingSelect from '../../../Atoms/DropDown/FloatingSelect';
import Image from '../../../Atoms/Image/Image';
import useStore from '../../../../store/useStore';
import UseWindowWidth from '../../../../hooks/useWindowWidth';
import { createPortal } from 'react-dom';
import Heading from '../../../Atoms/Heading/Heading';
import Link from '../../../Atoms/Link/Link';
import { getElementById } from '../Util';
import { FOOTER_CLICK_ACTION } from '../../../../constants/AnalyticsConstants';

interface FooterLastColumnProps {
  apiEndpoint?: {
    value: string;
  };
  dataSource?: string;
  language?: string;
  siteName?:string;
}

interface NavItem {
  title: string;
  AlternateText: string;
  href: string;
  CssClass: string;
  imageSrc: string;
  ImageAlt: string;
  AnalyticsText: string;
  AnalyticsTextAttributes: string;
  AdaAriaLabelText: string;
}

interface Language {
  Name: string;
  ImageUrl: string | null;
  Url: string;
  code: string;
  Country: string | null;
  languageName: string;
  IsCurrentLanguage: boolean;
}

const FooterLastColumn: React.FC<FooterLastColumnProps> = ({
  apiEndpoint,
  dataSource,
  siteName,
  language,
}) => {
  const { data } = useRequest({
    params: {
      apiEndpoint: apiEndpoint?.value,
      datasourceId: dataSource,
      siteName:siteName,
    },
  });
  const mediumDevice = UseWindowWidth() < 1024;
  const footerLastColumnPortal = getElementById('footer__last-column');

  const { setAttemptTracker, setAnalyticsProducts } = useStore();

  const links = _get(data, ['navigationSections', 0, 'navigationSectionItems'], []);
  const sectionName = _get(data, ['navigationSections', 0, 'sectionName'], '');
  const languages = _get(data, ['languages'], []);
  const currentLanguageFromAPI = _get(data, ['currentLanguage'], {});

  const [languageSelected, setLanguageSelected] = useState('');

  const analyticsHandler = (clickActionName:string, href: any) => {
    setAnalyticsProducts({
      clickActionName:clickActionName.trim(),
      startonlineorder: 0,
    });
    if(href.includes("subway.com")) 
    {
      setAttemptTracker([{ name: FOOTER_CLICK_ACTION }]);
    }    
  };

  useEffect(() => {
    if (data) {
      setLanguageSelected(_get(currentLanguageFromAPI, ['code']));
    }
  }, [data]);

  const linkElements =
    !_isEmpty(links) &&
    links.map((item: NavItem) => {
      const title = _get(item,['alternateText'],'');
      const analyticsText = _get(item, ['analyticsText'], '').replace(/\s+/g, '-').toLowerCase();
      const link = !mediumDevice ? (
        <><Image className="footer-lastcolumn__icon" imageSources={item.imageSrc} /> {title}</>
      ) :title;
      return (
        <li key={title} className="footer-lastcolumn__item">
          
          <Link testId={title} text={link} href={item.href} className="footer-lastcolumn__link" data-testauto-id ={analyticsText} onClick={() => analyticsHandler(title, item.href)} />
        </li>
      );
    });

    const languageOptions =
    !_isEmpty(languages) &&
    languages.map((languageCode: Language) => {
      return (
        <option key={languageCode.code} value={languageCode.code}>
          {languageCode.languageName}
        </option>
      );
    });

  const languageHandler = (value: string) => {
    if (value == language) return;
    const selectedLanguage = languages.find((item: any) => item.code == value);
    const languageName = selectedLanguage.languageName;

    const orderViewModel = (window as any).orderViewModel;
    if (language) {
      if (orderViewModel.store.id) {
        const lang = value.split('-')[0].toLowerCase();
        if (lang == 'es') {
          orderViewModel.store.languageCode = 'esp';
        } else {
          orderViewModel.store.languageCode = 'eng';
        }
        orderViewModel.save();
      }
      const currentUrl = window.location.href.toLowerCase();
      setAnalyticsProducts({
        startonlineorder: 0,
        clickActionName: languageName,
      });
      setAttemptTracker([{ name: 'footer_click_action' }]);
      window.location.href = currentUrl.replace(language.toLowerCase(), value.toLowerCase());
    }
  };

  return (
    footerLastColumnPortal &&
    createPortal(
      <>
        <Heading title={sectionName}  level="span" className="global-footer__title" />
        <div className="footer-lastcolumn__container">
          <ul className="footer-lastcolumn__list">{linkElements}</ul>
          <div className="footer-lastcolumn__languages">
            {!mediumDevice && (
              <Image
                className="footer-lastcolumn__icon"
                imageSources={_get(currentLanguageFromAPI, ['imageUrl'], '')}
              />
            )}
            <FloatingSelect
               label={''}
               aria-label={'language'}
              onChange={languageHandler}
              optionList={languageOptions}
              dataTestId={'language-dropdown'}
              data-testauto-id = {'language-dropdown'}
              value={languageSelected}
            />
          </div>
        </div>
      </>,
      footerLastColumnPortal,
    )
  );
};

export default FooterLastColumn;
